import React from "react";
import Grid from "@mui/material/Grid"; // Grid version 1
import Grid2 from "@mui/material/Unstable_Grid2"; // Grid version 2
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import "@fontsource/outfit";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "../Header/Header";
import { useNavigate } from "react-router";
const theme = createTheme();

export default function Subscription_Success() {
  let navigate = useNavigate();
  const currentDate = new Date().toDateString();
  // Outputs "Mon Aug 31 2020"
  let currTime = new Date().toLocaleTimeString()
  return (
    <>
      <Box sx={{ backgroundColor: "#F9FFFF" }}>
        <Box sx={{ padding: "20px" }}>
          <Header />
        </Box>

        <Grid container component="main" sx={{ height: "100vh" }}>
          <Grid xs={12}>
            <Box
              display="flex"
              bgcolor="#F9FFFF"
              flexDirection={"column"}
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            // fontFamily={"outfit"}
            >
              <img
                src="./images/Illustration.svg"
                alt="Illustration"
                width={"262px"}
                height={"262px"}
                mt={"120px"}
                sx={{
                  width: { xl: "500px", lg: "350px", md: "262px" },
                }}
              />

              {/* <Typography fontSize={"40px"} fontWeight={600} mt={""} color="#1A1824"> */}
              <Typography
                fontWeight={600}
                mt={""}
                color="#1A1824"
                sx={{
                  fontSize: {
                    xl: "65px",
                    lg: "40px",
                    md: "40px",
                    sm: "30px",
                    xs: "25px",
                  },
                }}
              >
                Subscription Activated
              </Typography>
              <Typography
                fontSize={"20px"}
                textAlign={"center"}
                fontWeight={"semibold"}
                mt={"16px"}
                mb={"56px"}
                color={"#545359"}
              >
                You will receive delivery on
                <br />
                {/* August 14, 2021 at 6 PM{" "} */}
                {currentDate.slice(4, currentDate.length)}
                {" "}at
                {" "}
                {currTime.slice(0, 1) + currTime.slice(7,currTime.length)}
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#2B817B",
                  width: "267px",
                  height: "48px",
                  color: "#FFFFFF",
                  fontSize: "16px",
                  fontWeight: "600",
                  textTransform: "capitalize",
                  letterSpacing: "0.015em",
                }}
                onClick={()=>navigate("/dashboard")}
              >
                See Details
              </Button>
              <Button
                onClick={() => navigate("/")}
                variant="outlined"
                sx={{
                  borderColor: "#2B817B",
                  width: "267px",
                  height: "48px",
                  color: "#2B817B",
                  textTransform: "capitalize",
                  letterSpacing: "0.015em",
                  fontSize: "16px",
                  fontWeight: "600",
                  mt: "16px",
                }}
              >
                Back to Home
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
